/* eslint-disable jsx-a11y/anchor-is-valid */
import {Column} from 'react-table'
import {Tab, TabList, TabPanel, Tabs} from 'react-tabs'
import {KTableProvider, useKTable} from '../../../../../../contexts/KTableProvider'
import {
  KTable,
  KTableHeader,
  KTableLoading,
  KTableSelectionCellNonMultiple,
} from '../../../../../../components/UI'
import {FC, useEffect, useMemo, useState} from 'react'
import {TabLavanderiaModel} from '../../../../../../models'
import {KTCard, KTSVG} from '../../../../../../../../_metronic/helpers'
import {useLavanderia} from '../../../../../../hooks/useLavanderia'
import {SelectModel, SupplierModel} from '../../../../model'
import {getSupplier} from '../../../../services'
import {MasiveUploadSupplier} from '../form/MasiveUploadSupplier'
import {useKhipu} from '../../../../../../hooks/useKhipu'
import moment from 'moment'
import {getMasterService} from '../../../../../central/services'

let obj: SupplierModel = {}

const TableSupplier: FC = () => {
  const {
    data,
    setData,
    setPagination,
    loading,
    setLoading,
    pagination,
    clearSelected,
    selectedOn,
    updateTable,
    setUpdateTable,
  } = useKTable()
  const {currentTabItem, changeCurrentTabItem, isAllowed} = useLavanderia()
  const {searchValues, clearSearchValues} = useKhipu()
  const [statusType, setStatusType] = useState<SelectModel[]>([])

  const getClientList = async () => {
    changeCurrentTabItem({...currentTabItem, loadingTable: false})
    // changeSearchValues({})

    setLoading(true)
    clearSelected()
    await new Promise((resolve) => setTimeout(resolve, 2000))
    const response = await getSupplier(searchValues, pagination.currentPage)
    setData(response.data.data)
    setLoading(false)
  }

  useEffect(() => {
    getClientList()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination])

  const handleViewPanel = (data: any) => {
    const getRow = data.row
    const getArrows = data.data
    const getData = getArrows[getRow.index]
    const obj: TabLavanderiaModel = {
      ...currentTabItem,
      showPanel: true,
      idToEdit: getData.id,
      content: {
        ...currentTabItem.content,
        detailPanel: 'tab-supplier',
      },
      idToDelete: '',
    }
    changeCurrentTabItem(obj)
    clearSelected()
  }

  const getStatusList = async () => {
    try {
      const response = await getMasterService({
        pageNumber: 1,
        size: 100,
        tableName: 'EstadoProveedor',
      })
      const data = response.data.data
      const mappedMaster = data.map((master) => ({
        value: master.codigo,
        label: master.nombreCorto,
      }))
      setStatusType(mappedMaster)
    } catch (error) {
      console.error('Error al obtener la lista de tipo de documento:', error)
    }
  }

  const handleGetId = (id: any) => {
    let idChange = id === currentTabItem.idToDelete ? '' : id
    const obj: TabLavanderiaModel = {
      ...currentTabItem,
      showPanel: false,
      idToDelete: idChange,
      idToEdit: '',
    }
    changeCurrentTabItem(obj)
  }

  const columns: Column<SupplierModel>[] = useMemo(
    () => [
      {
        Header: (props) => <KTableHeader tableProps={props} showSelect={false} />,
        id: 'selection',
        Cell: ({...props}) => (
          <KTableSelectionCellNonMultiple
            id={props.data[props.row.index].id}
            clickHandler={handleGetId}
          />
        ),
      },

      {
        Header: (props) => <KTableHeader tableProps={props} title='Ruc' name={'ruc'} searcheable />,
        accessor: 'ruc',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Razón Social' name={'razonSocial'} searcheable />
        ),
        accessor: 'razonSocial',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Dirección' name={'direccion'} searcheable />
        ),
        accessor: 'direccion',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Fecha Inicio'
            name='fechaInicioServicio'
            dateable
          />
        ),
        accessor: 'fechaInicioServicio',
        Cell: ({...props}) => (
          <div>
            {moment(props.row.original.fechaInicioServicio).local().format('DD/MM/YYYY') ===
            'Invalid date'
              ? ''
              : moment(props.row.original.fechaInicioServicio).local().format('DD/MM/YYYY')}
          </div>
        ),
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Fecha Fin' name='fechaFinServicio' dateable />
        ),
        accessor: 'fechaFinServicio',
        Cell: ({...props}) => (
          <div>
            {moment(props.row.original.fechaFinServicio).local().format('DD/MM/YYYY') ===
            'Invalid date'
              ? ''
              : moment(props.row.original.fechaFinServicio).local().format('DD/MM/YYYY')}
          </div>
        ),
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Estado'
            name={'estado'}
            selecteable
            data={statusType}
          />
        ),
        accessor: 'estado',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Ver' />,
        id: 'actions',
        Cell: ({...props}) => (
          <>
            {isAllowed('EDITAR') && (
              <div
                className='d-flex justify-content-center flex-shrink-0'
                onClick={() => handleViewPanel(props)}
              >
                <a href='#' className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
                  <KTSVG path='/media/icons/duotune/general/gen055.svg' className='svg-icon-3' />
                </a>
              </div>
            )}
          </>
        ),
      },
    ],
    [selectedOn, statusType],
  )

  useEffect(() => {
    setInitialPagination()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTabItem.loadingTable])

  const setInitialPagination = async () => {
    const {data: response} = await getSupplier(obj, pagination.currentPage)
    setPagination({
      perPage: 10,
      currentPage: 1,
      totalResults: response.total,
    })
  }

  useEffect(() => {
    setLoading(loading)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])

  useEffect(() => {
    getStatusList()
    return () => {
      clearSearchValues()
    }
  }, [])

  useEffect(() => {
    if (updateTable) {
      clearSelected()
      getClientList()
      setUpdateTable(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateTable])

  useEffect(() => {
    if (currentTabItem.loadingTable) {
      clearSelected()
      getClientList()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTabItem.loadingTable])

  return (
    <>
      {isAllowed('LISTAR') && (
        <KTCard shadow className='mx-2  w-100'>
          <KTable data={data} columns={columns} classNameProps='dataTablecentral' />
          {loading ? <KTableLoading title='Cargando...' /> : null}
        </KTCard>
      )}
    </>
  )
}

const TableSupplierWrapper = () => {
  const {isAllowed} = useLavanderia()
  return (
    <KTableProvider>
      <div className='sdx_content_tab_panel'>
        <Tabs className={'sdx_sub_react_tab_panel '}>
          <TabList className={'sdx_sub_tab_panel p-0'}>
            <Tab className={'sdx_sub_tab_panel_option'}>Listado de Proveedores</Tab>
            {isAllowed('MASIVO') && <Tab className={'sdx_sub_tab_panel_option'}>Carga Masiva</Tab>}
          </TabList>
          <TabPanel>
            <TableSupplier />
          </TabPanel>
          {isAllowed('MASIVO') && (
            <TabPanel>
              <MasiveUploadSupplier />
            </TabPanel>
          )}
        </Tabs>
      </div>
    </KTableProvider>
  )
}

export {TableSupplierWrapper}
